<template>
  <div
    id="layout"
    class="antialiased bg-white text-stone-900 font-sans border-b"
    :style="pageBackground ? { backgroundColor: pageBackground } : undefined"
  >
    <client-only>
      <Sidebars />
    </client-only>

    <header ref="header" :style="headerStyle">
      <ErrorBoundary>
        <client-only>
          <Notifications />
        </client-only>
        <Navbar />
      </ErrorBoundary>
      <slot name="banner" />
    </header>

    <ErrorBoundary>
      <main>
        <PageLoader />
        <slot />
      </main>
    </ErrorBoundary>

    <slot name="links-section">
      <ErrorBoundary>
        <LazyVisibleEventListLinksBlock hydrate-on-visible />
      </ErrorBoundary>
    </slot>
    <slot name="footer">
      <ErrorBoundary>
        <LazyVisibleFooter hydrate-on-visible :footer-block-items="footerBlock" />
      </ErrorBoundary>
    </slot>
  </div>
</template>
<script lang="ts" setup>
// before the first await so the scroll listener is live during hydration
const { headerStyle } = useAutoHideHeader(useTemplateRef('header'))

const { locale } = useI18n()
const route = useRoute()

// opt-in per page via definePageMeta({ pageBackground: '#f8f6f2' })
const pageBackground = computed(
  () => route.meta.pageBackground as string | undefined
)

const { data: footerData } = await useStrapiSingleType(
  `footer?locale=${locale.value}&populate[footerBlock][populate]=*`
)

const { setupValidationPolling, deactivateValidationPolling } =
  useCartValidation()

const { footerBlock = [] } = footerData?.value?.data || {}

onMounted(async () => {
  await setupValidationPolling()
})

onUnmounted(async () => {
  await deactivateValidationPolling()
})

useLayoutHead()
</script>

<style lang="css" scoped>
@reference '~/assets/css/tailwind.css';
#layout {
  box-sizing: border-box;
}

header {
  @apply sticky top-0 z-20;
  transition: top 0.3s ease;
}

main {
  min-height: 100vh;
  position: relative;
}
</style>

<style>
.Toastify__toast-container {
  max-width: 480px;
  --toastify-toast-width: max-content;
}
</style>
